<template lang="pug">
Tabs.ticket-hub
    //- contains-table: a panel card is flush (body padding 0) and its content
    //- carries the spacing, the way every paginated list in the admin is built.
    el-card.contains-table(shadow="always")
        ticket-list(scope="cms")
</template>

<script>
import Tabs from '@/extensions/communication/views/Partials/Tabs';
import TicketList from '@/extensions/tickets/views/TicketList';

export default {
    name: 'CmsTicketList',
    components: {
        Tabs,
        TicketList,
    },
};
</script>
